import { IActiveSkill } from "../ISkill";
import { IArrowCaster } from "../IArrowCaster";

export default class SniperShotSkill implements IActiveSkill {
  Name = "Sniper Shot";
  Description = "Fire a precise, powerful arrow with increased damage and speed.";
  MaxLevel = 5;
  IconKey = "skill_sniper";
  KeyBinding = "FOUR";

  ManaCost(level: number): number {
    return Math.max(15, 30 - level * 3);
  }

  CooldownMs(level: number): number {
    return Math.max(2500, 6000 - level * 700);
  }

  Execute(level: number, caster: IArrowCaster): boolean {
    const damageMultiplier = 2.0 + level * 0.5;
    const speedMultiplier = 1.5 + level * 0.2;
    caster.SpawnArrow({
      angle: caster.GetAimAngle(),
      damageMultiplier,
      speedMultiplier,
      isExploding: false,
      explosionRadius: 0,
      explosionDmgMult: 0,
    });
    return true;
  }
}
